import React__default, { useState, useEffect, useRef } from 'react';
import useClickOutside from '../../Hooks/useClickOutside/useClickOutside.js';
import 'copy-to-clipboard';
import '../../Hooks/useDateTimeFormat/useDateTimeFormat.js';
import 'use-debounce';
import '../../Hooks/useFromNow/useFromNow.js';
import 'crypto-js';
import '../../../node_modules/@faker-js/faker/dist/esm/chunk-3LPAMF3R.js';
import '../../../node_modules/@faker-js/faker/dist/esm/chunk-LSZKOVGW.js';
import '../../../node_modules/@faker-js/faker/dist/esm/chunk-GTEBSQTL.js';
import 'react-router-dom';
import '../../Providers/LanguageProvider/LanguageProvider.js';
import '@azure/msal-react';
import { createPortal } from 'react-dom';

const Menu = ({ open, anchorEl, anchorOrigin = { vertical: 'top', horizontal: 'left' }, menuOrigin = { vertical: 'top', horizontal: 'left' }, children, width, offset = { vertical: 0, horizontal: 0 }, closeOnClickOutside = true, position = 'fixed', onClose, }) => {
    const [menuShown, setMenuShown] = useState(open);
    const [menuCoords, setMenuCoords] = useState(null);
    useEffect(() => {
        setMenuShown(open);
        if (anchorEl) {
            if (anchorEl instanceof HTMLElement) {
                console.log(anchorEl.getBoundingClientRect());
                const boundingRect = anchorEl.getBoundingClientRect();
                setMenuCoords({
                    left: boundingRect.right,
                    top: boundingRect.top,
                });
            }
            else {
                if (anchorEl.left && anchorEl.top) {
                    setMenuCoords({ left: anchorEl.left, top: anchorEl.top });
                }
            }
        }
    }, [open, anchorEl]);
    const ref = useRef(null);
    const handleClose = () => {
        setMenuShown(!menuShown);
        setMenuCoords(null);
        onClose();
    };
    useClickOutside(ref, handleClose, menuShown && closeOnClickOutside);
    if (!menuCoords)
        return;
    return createPortal(React__default.createElement("div", { ref: ref, style: {
            position: position,
            textAlign: 'left',
            top: menuCoords.top + offset.vertical,
            left: menuCoords.left + offset.horizontal,
            whiteSpace: 'nowrap',
            zIndex: 10,
            width: width,
            backgroundColor: '#FFFFFF',
            border: 'solid 1px #CCCCCC',
            borderRadius: 4,
            boxShadow: '3px 3px 10px rgba(0, 0, 0, 0.15)',
            display: !menuShown ? 'none' : '',
        } }, children), document.body);
};

export { Menu as default };
//# sourceMappingURL=Menu.js.map
